import useSWR from 'swr'
import { getUserPublicInfo } from '@/data/api/user'

type FetcherProps = [
  url: string,
  identifier: {
    key: 'id' | 'username' | 'email'
    value?: string
  }
]

async function fetcher([ , identifier ]: FetcherProps) {
  const result = await getUserPublicInfo({ [identifier.key]: identifier.value })
  if ('error' in result) {
    return Promise.reject(result.error)
  }
  return result
}

export default function useUser(identifier: FetcherProps[1]) {
  const { data: user, mutate: mutateUser, isLoading } = useSWR(identifier.value ? [ '/api/user', identifier ] : null, fetcher, {
    revalidateIfStale: false,
  })

  return { user, mutateUser, isLoading }
}
